import { dcrypt } from "./encrypt_decrypt";
import { characters1, characters2 } from "./chars";

const checkPassword = (db) => {
  if (db) {
    if (localStorage.getItem("Safe-notes")) {
      const localValue = dcrypt(
        localStorage.getItem("Safe-notes"),
        characters2
      );
      let storedValue = null;
      var tx = db.transaction("passkey", "readonly");
      var store = tx.objectStore("passkey");
      var request = store.openCursor();
      request.onsuccess = (e) => {
        var result = e.target.result;
        if (!!result === false) {
          return;
        }
        storedValue = dcrypt(result.value.text, characters1);
        if (storedValue.join("") !== localValue.join("")) {
          window.location.href = "/";
        }
      };
    } else {
      window.location.href = "/";
    }
  }
};
export { checkPassword };
